import { AppointmentMultiple } from 'model/NewMultipleBooking';

export const APPOINTMENTS_PER_PAGE = 6;

export const getAppointmentsTotalCount = (appointments: Array<AppointmentMultiple>) =>
    appointments.reduce((total, appt) => total + appt.variableData.length, 0);

export const getAppointmentsTotalPages = (appointments: Array<AppointmentMultiple>) =>
    Math.max(1, Math.ceil(getAppointmentsTotalCount(appointments) / APPOINTMENTS_PER_PAGE));

export const paginateMultipleAppointments = (
    appointments: Array<AppointmentMultiple>,
    page: number,
    pageSize = APPOINTMENTS_PER_PAGE
): Array<AppointmentMultiple> => {
    const flat = appointments.flatMap(appt =>
        appt.variableData.map(data => ({
            appt,
            data
        }))
    );

    const start = (page - 1) * pageSize;
    const pageItems = flat.slice(start, start + pageSize);

    const byPet = new Map<number, AppointmentMultiple>();

    pageItems.forEach(({ appt, data }) => {
        const existing = byPet.get(appt.petId);
        if (existing) {
            existing.variableData.push(data);
            return;
        }

        byPet.set(appt.petId, {
            ...appt,
            variableData: [data]
        });
    });

    return Array.from(byPet.values());
};
